import { Link, useNavigate } from 'react-router-dom';
import { Box, Grid, IconButton, Skeleton, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getCaptcha, passwordRecoveryOtp } from '../../../apis/auth';
import { publicRoutes } from '../../../configs/routes';
import { msisdnValidation } from '../../../utils/validation';
import logo from '@images/logo.png';
import bgLogin from '@images/login/knowledge.svg';
import CustomButton from '../../../components/UI/CustomButton';
import CustomInput from '../../../components/UI/CustomInput';
import RefreshIcon from '@mui/icons-material/Refresh';
import './forget.scss';

const ForgetPassword = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:991px)');
  const [disabled, setDisabled] = useState<boolean>(true);
  const [msisdn, setMsisdn] = useState('');
  const [msisdnError, setMsisdnError] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [captchaBase64, setCaptchaBase64] = useState('');
  const [captcha, setCaptcha] = useState('');
  const [captchaError] = useState(false);
  const [keyCaptcha, setKeyCaptcha] = useState<string>('');
  const [captchaLoading, setCaptchaLoading] = useState<boolean>(true);

  async function handleSubmit(event: { preventDefault: () => void }) {
    event.preventDefault();

    const mobileNumber = msisdn.startsWith('0')
      ? `+98${msisdn.slice(1, msisdn.length)}`
      : `+98${msisdn}`;
    setLoading(true);

    passwordRecoveryOtp(mobileNumber, captcha, keyCaptcha)
      .then(() => navigate(publicRoutes.setPassword, { state: { msisdn } }))
      .catch((e) => console.log({ e }))
      .finally(() => setLoading(false));
  }

  const getCaptchaData = () => {
    setCaptchaLoading(true);
    getCaptcha()
      .then(async (res: any) => {
        setCaptchaBase64(res.captcha);
        setKeyCaptcha(res.key);
      })
      .finally(() => setCaptchaLoading(false));
  };

  useEffect(() => {
    if (!msisdnValidation(msisdn)) setDisabled(false);
    else setDisabled(true);
  }, [msisdn]);

  useEffect(() => {
    getCaptchaData();
  }, []);

  const FormContent = (
    <>
      <form className='form' onSubmit={handleSubmit}>
        <Box className='logo'>
          <img src={logo} alt='' width={140} />
        </Box>

        <Typography color='text.main' fontWeight='bold' fontSize='large' mt={4}>
          فراموشی رمز عبور
        </Typography>

        <Typography color='text.main' fontSize='small' fontWeight='lighter' mb={3} mt={1}>
          لطفا شماره موبایل خود را وارد کنید.
        </Typography>

        <CustomInput
          label={msisdn ? 'شماره همراه' : ''}
          placeholder='شماره همراه'
          value={msisdn}
          helperText={msisdnError ? 'شماره همراه اشتباه است.' : ''}
          maxLength={msisdn.startsWith('0') ? 11 : 10}
          error={msisdnError}
          inputMode='numeric'
          onChangeHandler={(value) => {
            setMsisdn(value);
            if (msisdnValidation(value) && value !== '') setMsisdnError(true);
            else setMsisdnError(false);
          }}
        />

        <Grid container spacing={1}>
          <Grid item xs={6}>
            <CustomInput
              label={captcha ? 'تصویر کپچا' : ''}
              placeholder='تصویر کپچا'
              value={captcha}
              helperText={captchaError ? 'شماره همراه اشتباه است.' : ''}
              maxLength={10}
              error={captchaError}
              inputMode='numeric'
              onChangeHandler={(value) => setCaptcha(value)}
            />
          </Grid>

          <Grid item xs={6} className='flexCenter'>
            {captchaLoading ? (
              <Skeleton
                variant='rectangular'
                width='100%'
                height='44px'
                sx={{ borderRadius: '0.5rem' }}
              />
            ) : (
              <Box className='captchaContainer'>
                <img
                  src={`data:image/jpeg;base64,${captchaBase64}`}
                  alt=''
                  width={100}
                  height={48}
                />
                <IconButton onClick={getCaptchaData}>
                  <RefreshIcon color='primary' />
                </IconButton>
              </Box>
            )}
          </Grid>
        </Grid>

        <Box display='flex' mt={2} gap={1} width='100%'>
          <CustomButton
            fullWidth
            variant='contained'
            disabled={disabled || loading}
            type='submit'
            loading={loading}
          >
            <Typography>ادامــه</Typography>
          </CustomButton>
        </Box>

        <Box className='termsContainer'>
          <Typography className='terms' color='text.dark' mt={2}>
            آیا اطلاعات اکانت کاربری خود را میدانید؟ پس{' '}
            <Link to={publicRoutes.login} className='link'>
              <span className='register'>وارد</span>
            </Link>{' '}
            شوید
          </Typography>
        </Box>
      </form>
    </>
  );

  const MobileContent = (
    <Box className='mobileContent'>
      <Box>
        <img src={bgLogin} alt='' className='img' />
      </Box>

      <Box className='mainContent'>{FormContent}</Box>
    </Box>
  );

  if (isMobile) return MobileContent;

  return (
    <Grid container className='grid' dir='ltr'>
      <Grid item xl={6} lg={6} md={12} xs={12} className='leftGrid'>
        <img src={bgLogin} alt='' className='img' />
      </Grid>
      <Grid item xl={6} lg={6} md={12} xs={12} dir='rtl' className='rightGrid'>
        {FormContent}
      </Grid>
    </Grid>
  );
};

export default ForgetPassword;
